// components/StarflowHeroSmallText.jsx
import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Hero = styled.div`
  position: relative;
  width: 100%;
  height: 90vh;
  min-height: 700px;
  background: #000;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 40px;
  box-shadow: 0 50px 120px rgba(0, 0, 0, 0.9);
  margin: 2rem 0;

  @media (max-width: 768px) {
    height: 80vh;
    min-height: 580px;
    border-radius: 32px;
  }
`;

// Космический поток звёзд — без блюра, чётко и мощно
const StarStream = () => {
  const stars = Array.from({ length: 80 }, (_, i) => ({
    x: (Math.random() - 0.5) * 200,
    y: (Math.random() - 0.5) * 200,
    size: 1 + Math.random() * 1.5,
    duration: 1.2 + Math.random() * 1.8,
    delay: Math.random() * 2,
  }));

  return (
    <>
      {stars.map((star, i) => (
        <motion.div
          key={i}
          style={{
            position: 'absolute',
            width: star.size,
            height: star.size,
            background: '#ffffff',
            borderRadius: '50%',
            left: '50%',
            top: '50%',
            x: star.x,
            y: star.y,
            opacity: 0,
          }}
          animate={{
            x: star.x * 6,
            y: star.y * 6,
            opacity: [0, 1, 0],
            scale: [1, 2.5, 0],
          }}
          transition={{
            duration: star.duration,
            repeat: Infinity,
            delay: star.delay,
            ease: "easeOut",
          }}
        />
      ))}
    </>
  );
};

// Переведённый градиентный текст
const GradientText = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        textAlign: 'center',
        zIndex: 10,
        padding: '0 2rem',
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      <h1
        style={{
          fontSize: 'clamp(3.5rem, 10vw, 7rem)',
          fontWeight: 900,
          margin: 0,
          lineHeight: 0.9,
          letterSpacing: '-0.03em',
          background: 'linear-gradient(180deg, #ffffff 0%, #6e6e6eff 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          textShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
        }}
      >
        {t('hero_title_1')}
      </h1>
      <h1
        style={{
          fontSize: 'clamp(3.5rem, 10vw, 7rem)',
          fontWeight: 900,
          margin: '0.04em 0 0',
          lineHeight: 0.9,
          letterSpacing: '-0.03em',
          background: 'linear-gradient(180deg, #ffffff 0%, #000000 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          textShadow: '0 4px 20px rgba(0, 0, 0, 0.6)',
        }}
      >
        {t('hero_title_2')}
      </h1>
    </div>
  );
};

const StarflowHeroSmallText = () => {
  return (
    <Hero>
      <StarStream />
      <GradientText />
    </Hero>
  );
};

export default StarflowHeroSmallText;